import React from "react";
import { m, useReducedMotion } from "framer-motion";

const EASE_OUT = [0.22, 1, 0.36, 1];

const REVEALS = Object.freeze({
  fade: Object.freeze({
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.24, ease: EASE_OUT } },
  }),
  up: Object.freeze({
    hidden: { opacity: 0, transform: "translate3d(0, 16px, 0)" },
    show: { opacity: 1, transform: "translate3d(0, 0, 0)", transition: { duration: 0.44, ease: EASE_OUT } },
  }),
  scale: Object.freeze({
    hidden: { opacity: 0, transform: "translate3d(0, 12px, 0) scale(0.985)" },
    show: { opacity: 1, transform: "translate3d(0, 0, 0) scale(1)", transition: { duration: 0.46, ease: EASE_OUT } },
  }),
});

function triggerFor(play, amount) {
  return play === "mount"
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount } };
}

export function SolutionReveal({ as = "div", variant = "up", amount = 0.18, play = "view", className, children, ...rest }) {
  const reduceMotion = useReducedMotion();
  const MotionElement = m[as] || m.div;
  if (reduceMotion) return <MotionElement className={className} {...rest}>{children}</MotionElement>;
  return (
    <MotionElement
      className={className}
      variants={REVEALS[variant] || REVEALS.up}
      initial="hidden"
      {...triggerFor(play, amount)}
      {...rest}
    >
      {children}
    </MotionElement>
  );
}

export function SolutionStagger({ as = "div", stagger = 0.05, delay = 0.04, amount = 0.16, play = "view", className, children, ...rest }) {
  const reduceMotion = useReducedMotion();
  const MotionElement = m[as] || m.div;
  if (reduceMotion) return <MotionElement className={className} {...rest}>{children}</MotionElement>;
  return (
    <MotionElement
      className={className}
      variants={{ hidden: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
      initial="hidden"
      {...triggerFor(play, amount)}
      {...rest}
    >
      {children}
    </MotionElement>
  );
}

export function SolutionStaggerItem({ as = "div", variant = "up", className, children, ...rest }) {
  const reduceMotion = useReducedMotion();
  const MotionElement = m[as] || m.div;
  if (reduceMotion) return <MotionElement className={className} {...rest}>{children}</MotionElement>;
  return (
    <MotionElement className={className} variants={REVEALS[variant] || REVEALS.up} {...rest}>
      {children}
    </MotionElement>
  );
}

export { EASE_OUT as SOLUTION_EASE_OUT, REVEALS as SOLUTION_REVEALS };
